import Compose from "./Compose";
import { ActionItem } from "../types";

export type CacheItem = Compose | ActionItem;

let cacheList: Array<CacheItem> = [];

export function push(compose: CacheItem): void {
    cacheList.push(compose);
}

export function getAllByPage(el: Element): Array<CacheItem> {
    const {
        popArr,
        stayArr
    }: {
        popArr: Array<CacheItem>;
        stayArr: Array<CacheItem>;
    } = cacheList.reduce(
        (
            map,
            cp
        ): {
            popArr: Array<CacheItem>;
            stayArr: Array<CacheItem>;
        } => {
            let node: Element = null;

            if (cp instanceof Compose) {
                node = cp.page.node;
            } else {
                node = cp.appEl;
            }

            if (el && el.isSameNode(node)) {
                map.popArr.push(cp);
            } else {
                map.stayArr.push(cp);
            }

            return map;
        },
        {
            popArr: [],
            stayArr: []
        }
    );

    cacheList = stayArr;

    return popArr;
}
